import React from 'react';
import { Body1BoldStyleObject, Subtitle1StyleObject, WebTitle3StyleObject } from '../../config/designSystem/typography';
import { type GradientTextProps } from './GradientText.native';



const GradientText = ({ gradient, label, typo }: GradientTextProps) => {
  const { left, right, orientationAngle } = gradient;
  let textStyle = Body1BoldStyleObject();
  switch(typo) {
  case 'Title3':
    textStyle = WebTitle3StyleObject();
    break;
  case 'Subtitle1':
    textStyle = Subtitle1StyleObject();
    break;
  case 'Body1Bold':
    textStyle = Body1BoldStyleObject();
    break;
  }


  // Define styles for the gradient text effect
  const gradientStyle = {
    backgroundImage: `linear-gradient(${orientationAngle}deg, ${left}, ${right})`,
    WebkitBackgroundClip: 'text',   // Ensures the gradient is clipped to span
    backgroundClip: 'text',         // Cross-browser compatibility
    color: 'transparent',           // Makes the text itself transparent to show the gradient
    display: 'inline-block',
  };

  return (
    <div style={{  display: 'inline-block' }}>
      <span style={{ ...textStyle, ...gradientStyle }}>
        {label}
      </span>
    </div>
  );
};

export default GradientText;
